/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { LocationOn } from '@material-ui/icons';
import { defaultErrorMessage } from '../../constants';
import ErrorModal from '../Shared/ErrorModal';
import LatestModalDesign from '../Shared/LatestModalDesign';
import LoadingOverlay from '../Shared/LoadingOverlay';
import { setDefaultAddress } from '../Shared/Helpers';

class DefaultAddressConfirmModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showErrorModal: false,
      error: null,
    };

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
  }

  handleClose() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleConfirm(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    this.setState({ loading: true });

    const addressId = this.props.address?.id;
    
    if (!addressId) {
      this.setState({
        loading: false,
        showErrorModal: true,
        error: 'Address ID is required',
      });
      return;
    }

    setDefaultAddress(
      addressId,
      // Success callback
      (response) => {
        this.setState({ loading: false });
        const { success, result } = response.data;

        if (success || result) {
          // Call parent's success callback to refresh the list
          if (this.props.onSuccess) {
            this.props.onSuccess(response.data);
          }
          // Close the modal
          this.handleClose();
        } else {
          const message = get(response, 'data.errors.message', defaultErrorMessage);
          this.setState({ showErrorModal: true, error: message });
        }
      },
      // Error callback
      (error) => {
        this.setState({ loading: false });
        if (error && error.response && error.response.data) {
          const message = get(error.response.data, 'errors.0.message', defaultErrorMessage);
          this.setState({ showErrorModal: true, error: message });
        } else {
          this.setState({
            showErrorModal: true,
            error: defaultErrorMessage,
          });
        }
      }
    );
  }

  closeErrorModal() {
    this.setState({ showErrorModal: false, error: null });
  }

  render() {
    const { isOpen, address } = this.props;
    const { loading, showErrorModal, error } = this.state;

    return (
      <>
        <LatestModalDesign
          isOpen={isOpen}
          title="Set Default Address"
          close={this.handleClose}
          apply={this.handleConfirm}
          applyBtnCopy="Set as Default"
          cancelBtnCopy="Cancel"
          disabled={loading}
          contentExtraClass="default-address-confirm-modal"
        >
          <div className="mb-16">
            <p className="size-16-24 contentPrimary mb-16">
              Are you sure you want to set this address as your default?
            </p>
            
            {address && (
              <div className="bg-light-gray p-16 br-rd-8">
                <div className="d-flex align-items-center mb-4">
                  <LocationOn className="mr-8" style={{ color: '#323232', fontSize: 20 }} />
                  <div className="flex-1">
                    <div className="size-16-20 contentPrimary font-weight-bold mb-4">
                      {address.address_line_1}
                    </div>
                    <div className="size-14-20 contentSecondary">
                      {[address.city, address.state, address.zip_code, address.country]
                        .filter(Boolean)
                        .join(', ')}
                    </div>
                    {address.address_line_2 && (
                      <div className="size-14-20 contentSecondary">
                        {address.address_line_2}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <p className="size-14-20 contentSecondary mt-16">
              This address will be automatically selected for future bookings.
            </p>
          </div>
        </LatestModalDesign>

        {showErrorModal && (
          <ErrorModal isOpen={showErrorModal} close={this.closeErrorModal}>
            <p>{error}</p>
          </ErrorModal>
        )}

        <LoadingOverlay showLoader={loading} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
});

DefaultAddressConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  address: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default connect(mapStateToProps)(DefaultAddressConfirmModal);